const defaultFormat = /(\d{1,4})/g;

const cards = [
    {
        type: 'amex',
        pattern: /^3[47]/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
        numberLength: [15],
    },
    {
        type: 'dankort',
        pattern: /^5019/,
        format: defaultFormat,
        numberLength: [16],
    },
    {
        type: 'hipercard',
        pattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
        format: defaultFormat,
        numberLength: [14, 15, 16, 17, 18, 19],
    },
    {
        type: 'dinersclub',
        pattern: /^(36|38|30[0-5])/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
        numberLength: [14],
    },
    {
        type: 'discover',
        pattern: /^(6011|65|64[4-9]|622)/,
        format: defaultFormat,
        numberLength: [16],
    },
    {
        type: 'unionpay',
        pattern: /^(62|81)/,
        format: defaultFormat,
        numberLength: [16, 17, 18, 19],
    },
    {
        type: 'jcb',
        pattern: /^(35|2131|1800)/,
        format: defaultFormat,
        numberLength: [16],
    },
    {
        type: 'laser',
        pattern: /^(6706|6771|6709)/,
        format: defaultFormat,
        numberLength: [16, 17, 18, 19],
    },
    {
        type: 'elo',
        pattern: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|4(0[5-9]|3[0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8])|9([2-6][0-9]|7[0-8])|541|700|720|901)|651652|655000|655021)/,
        format: defaultFormat,
        numberLength: [16],
    },
    {
        type: 'eurocard',
        pattern: /^(54130610|55595188)/,
        format: defaultFormat,
        numberLength: [16],
    },
    {
        type: 'mastercard',
        pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
        format: defaultFormat,
        numberLength: [16],
    },
    {
        type: 'visaelectron',
        pattern: /^4(026|17500|405|508|844|91[37])/,
        format: defaultFormat,
        numberLength: [16],
    },
    {
        type: 'visa',
        pattern: /^4/,
        format: defaultFormat,
        numberLength: [13, 16, 19],
    },
    {
        type: 'maestro',
        pattern: /^(5(0|[6-9])|6(0|[2-9]))/,
        format: defaultFormat,
        numberLength: [12, 13, 14, 15, 16, 17, 18, 19],
    },
];

const luhnCheck = (ccNumber) => {
    const luhnDigit = parseInt(ccNumber.substring(ccNumber.length - 1, ccNumber.length), 10);
    const luhnLess = ccNumber.substring(0, ccNumber.length - 1);

    let sum = 0;
    for (let i = 0; i < luhnLess.length; i++ ) {
        sum += parseInt(luhnLess.substring(i , i + 1), 10);
    }

    const delta = [0, 1, 2, 3, 4, -4, -3, -2, -1, 0];
    for (let i = luhnLess.length - 1; i >= 0; i -= 2 ) {
        const deltaIndex = parseInt(luhnLess.substring(i, i + 1), 10);
        const deltaValue = delta[deltaIndex];
        sum += deltaValue;
    }

    let mod10 = sum % 10;
    mod10 = 10 - mod10;

    if (mod10 === 10) {
        mod10 = 0;
    }

    return mod10 === luhnDigit;
};

const clearCard = (cardNumber) => {
    return (cardNumber + '').replace(/\s+|-/g, '');
};

const getCardType = (cardNumber, clear = false): any => {
    cardNumber = clearCard (cardNumber);

    const cardBrand = cards.find((card) => card.pattern.test(cardNumber));
    return cardBrand ? clear ? cardBrand : cardBrand.type : undefined;
};

const validateCard = (cardNumber) => {
    cardNumber = clearCard(cardNumber);

    if (!/^\d+$/.test(cardNumber)) {
        return false;
    }
    const card = getCardType(cardNumber, true);
    if (!card || (card && !card.numberLength.find((item) => item === cardNumber.length))) {
        return false;
    }
    return (card.type !== 'unionpay') ? luhnCheck(cardNumber) : true;
};

export {
    getCardType,
    validateCard,
    clearCard,
};

